// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/burger/burger-top.scss
 ** module id = 37
 ** module chunks = 0 1
 **/